module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/asphotofamily-avatar-c17e50e7c79def627dfb7eb28a8a4387.jpg";